/**
 * @param {import('@classapp-tech/edna').OptionItem[]} markers
 * @param {import('@classapp-tech/edna').OptionItem} option
 */

export function updateMarkersWithChildren(markers, option) {
  return markers.filter((marker) => marker !== option.id);
}
